import { ZyStudioIcon } from '@/components/tiptap-editor/tiptap-icons/zystudio-icon';
import { isSelectionTopNode } from '@/lib/zy-tiptap-utils';
import { forwardRef } from 'react';
import { GenericExtensionButton, type GenericExtensionButtonProps } from '../generic-extension-button';

export const ZyStudioButton = forwardRef<
    HTMLButtonElement,
    Omit<GenericExtensionButtonProps, 'extensionName' | 'extensionType' | 'icon' | 'label' | 'command'>
>((props, ref) => (
    <GenericExtensionButton
        extensionName="zyStudio"
        extensionType="node"
        icon={ZyStudioIcon}
        isDisabled={editor => !isSelectionTopNode(editor)}
        label="Insert zyStudio"
        command={editor => editor.commands.insertZyStudio()}
        ref={ref}
        {...props}
    />
));

ZyStudioButton.displayName = 'ZyStudioButton';

export default ZyStudioButton;
